<template lang="pug">
  .component-backoffice-edit-parking-group
    modal-reveal(sizing="small", ref="modalEditPG")
      button.button(slot="trigger") Edit
      h2 Edit Parking Group - {{item.name}}
      label Name
        input(type="text", v-model="item.name")
      BookingModeSelect(v-model="item.reservation_type")
      label Vat
        select(v-model="vat_id")
          option(:value="null") Select custom vat
          option(v-for="vat in vats", :value="vat.id") {{vat.description }} ({{vat.name}} {{vat.percentage}}%)
      button.button(@click="edit") Save
</template>

<script>
import ModalReveal from "../../../foundation/ModalReveal";
import KeplerBackofficeSdk from "../../../../../lib/kepler/backoffice";
import BookingModeSelect from '../../../BookingModeSelect'
import {mapState} from "vuex";

export default {
  name: "EditParkingGroup",
  components: {BookingModeSelect, ModalReveal},
  props: ['item'],
  data() {
    return {
      vat_id: null
    }
  },
  created() {
    if (this.item.vat){
      this.vat_id = this.item.vat.id
    }
  },
  methods: {
    edit() {

      var modal = this.$refs.modalEditPG
      this.item.vat_id = this.vat_id

      KeplerBackofficeSdk.parkingGroups.select(this.item.id).edit(this.item, (data) => {
        modal.close()
      })
    }
  },
  computed: {
    ...mapState({
      vats: state => state.configuration.vats,
    }),
  },
}
</script>

<style lang="sass">

</style>



// WEBPACK FOOTER //
// EditParkingGroup.vue?0aff9d7e